import React from 'react';
import PropTypes from 'prop-types';

const TextAreaField = ({
  label, id, name, value, onChange, type, row, col,
}) => (
  <div className="flex flex-wrap mx-3 w-full">
    <div className="flex flex-col w-full px-3 lg:mb-6">
      <label
        htmlFor={name}
        className="text-gray-400 text-sm mb-2"
      >
        {label}
        <span className="text-red-500">*</span>
      </label>

      <textarea
        className="border-2 border-gray-500 bg-gray-300 px-5 rounded-md text-sm text-gray-500 text-bold leading-tight focus:outline-none focus:bg-white"
        id={id}
        name={name}
        placeholder={label}
        onChange={onChange}
        type={type}
        value={value}
        rows={row}
        cols={col}
      />
    </div>
  </div>
);

export default TextAreaField;

TextAreaField.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  row: PropTypes.number.isRequired,
  col: PropTypes.number.isRequired,
};
